// swipers

class collectionSwiper extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const progressbar = this.querySelector(".swiper-pagination");
        const cardType = this.getAttribute("card-type");
        const next = this.querySelector(".swiper-button-next");
        const prev = this.querySelector(".swiper-button-prev");

        new Swiper(this, {
            slidesPerView: cardType == 'portrait' ? 1.7 : 1.2, 
            spaceBetween: 13,
            freeMode: true,
            grabCursor: true,      
            watchOverflow: true,  
            mousewheel: {
                forceToAxis: true,
            },
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.2,
                    spaceBetween: 30,
                },
            },
        });
    }
}

if(!customElements.get('fs-collection-swiper')){
    customElements.define('fs-collection-swiper', collectionSwiper);
}


class imageSwiper extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const progressbar = this.querySelector(".swiper-pagination");
        const cardType = this.getAttribute("card-type");
        const next = this.querySelector(".swiper-button-next");
        const prev = this.querySelector(".swiper-button-prev");

        new Swiper(this, {
            slidesPerView: 1.7, 
            spaceBetween: 13,
            freeMode: true,
            grabCursor: true,      
            watchOverflow: true,  
            mousewheel: {
                forceToAxis: true,
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                },
            },
        });
    }
}

if(!customElements.get('fs-image-slider')){
    customElements.define('fs-image-slider', imageSwiper);
}


class featProdSwiper extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const next = this.querySelector(".swiper-button-next");
        const prev = this.querySelector(".swiper-button-prev");
        
        new Swiper(this, {
            slidesPerView: 2.2, 
            spaceBetween: 13,
            freeMode: true,
            grabCursor: true,      
            watchOverflow: true,  
            mousewheel: {
                forceToAxis: true,
            },
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.2,
                    spaceBetween: 20,
                },
            },
        });
    }
}

if(!customElements.get('fs-feat-prod-slider')){
    customElements.define('fs-feat-prod-slider', featProdSwiper);
}

class TabProdSwiper extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const next = this.querySelector(".swiper-button-next");
        const prev = this.querySelector(".swiper-button-prev");
        const bar = this.querySelector(".swiper-pagination");

        new Swiper(this, {
            slidesPerView: 2.2, 
            spaceBetween: 13,
            freeMode: true,
            grabCursor: true,      
            watchOverflow: true,  
            mousewheel: {
                forceToAxis: true,
            },
            pagination: {
                el: bar,
                type: "progressbar",
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 4.2,
                    spaceBetween: 20,
                },
            },
        });
    }
}

if(!customElements.get('fs-prod-tab-slider')){
    customElements.define('fs-prod-tab-slider', TabProdSwiper);
}

class GridProdSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.resizeTimer = null;
  }

  connectedCallback() {
    this.initSwiper();

    // debounce resize
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  handleResize = () => {
    clearTimeout(this.resizeTimer);

    this.resizeTimer = setTimeout(() => {
      console.log("swiper re init");

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      this.initSwiper();
    }, 200);
  };

  initSwiper() {
    const next = this.querySelector(".swiper-button-next");
    const prev = this.querySelector(".swiper-button-prev");
    const bar = this.querySelector(".swiper-pagination");

    this.swiper = new Swiper(this, {
      slidesPerView: 2.2,
      spaceBetween: 13,
      freeMode: true,
      grabCursor: true,
      watchOverflow: true,

      grid: {
        rows: 2,
        fill: "row",
      },

      mousewheel: {
        forceToAxis: true,
      },

      pagination: {
        el: bar,
        type: "progressbar",
      },

      navigation: {
        nextEl: next,
        prevEl: prev,
      },

      breakpoints: {
        500: {
          slidesPerView: 3.2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 6.2,
          spaceBetween: 10,
        },
        1041: {
          slidesPerView: 8.2,
          spaceBetween: 10,
        },
      },
    });
  }
}

if (!customElements.get("fs-prod-grid-slider")) {
  customElements.define("fs-prod-grid-slider", GridProdSwiper);
}


class FsDragable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 10,
      freeMode: true,
      grabCursor: true,      
      watchOverflow: true,
      mousewheel:{
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 30,
        },
      },
    });
  }
}

if (!customElements.get("fs-dragable")) {
  customElements.define("fs-dragable", FsDragable);
}

class FsMarque extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new Swiper(this, {
      slidesPerView: 3,
      loop: true,  
      speed: 3000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        520: {
          slidesPerView: 6,
        },
        992: {
          slidesPerView: 8,
        },
      },
    });
  }
}

if (!customElements.get("fs-marque")) {
  customElements.define("fs-marque", FsMarque);
}

class FsBlogSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const next = this.closest(".featured-blog__wrapper").querySelector(".swiper-button-next");
    const prev = this.closest(".featured-blog__wrapper").querySelector(".swiper-button-prev");

    new Swiper(this, {
      slidesPerView: 1.5,
      spaceBetween: 30,
      freeMode: true,
      grabCursor: true,      
      watchOverflow: true,  
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      breakpoints: {
        768: {
          spaceBetween: 60,
          slidesPerView: 2.5,
        },
      },
    });
  }
}

if (!customElements.get("fs-blog-slider")) {
  customElements.define("fs-blog-slider", FsBlogSlider);
}



class FsThumbSlider extends HTMLElement {
  constructor() {
    super();
    this.mainSlider = null;
    this.thumbSlider = null;
  }

  connectedCallback() {
    const mainEl = this.querySelector(".fs-slider-main");
    const thumbEl = this.querySelector(".fs-slider-thumb");

    if (!mainEl || !thumbEl) return;

    // init thumb slider first
    this.thumbSlider = new Swiper(thumbEl, {
      slidesPerView: "auto",
      spaceBetween: 10,
      freeMode: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      watchOverflow: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
        },
      },
    });

    // init main slider and connect thumbs
    this.mainSlider = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      watchOverflow: true,
      grabCursor: true,
      thumbs: {
        swiper: this.thumbSlider,
      },
    });
  }
}

if (!customElements.get("fs-thumb-slider")) {
  customElements.define("fs-thumb-slider", FsThumbSlider);
}




// others


class FsProdTabs extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.tabTriggers = this.querySelectorAll('.tab_trigger');
        this.tabContents = this.querySelectorAll('.tab');
        const btnTop = this.closest(".products-grid-section").querySelector(".section-header__line a.button");
        const btnBottom = this.closest(".products-grid-section").querySelector(".fs_bottom_btn a.button");

        this.tabTriggers.forEach((tabTrigger) => {
            tabTrigger.addEventListener('click', (e) => {
                this.tabTriggers.forEach((tabTrigger) => {
                    tabTrigger.classList.remove('active');
                });
                this.tabContents.forEach((tabContent) => {
                    tabContent.classList.remove('active');
                });
                tabTrigger.classList.add('active');
                this.tabContents.forEach((tabContent) => {
                    if(tabContent.id === tabTrigger.dataset.tab){
                        tabContent.classList.add('active');
                    }
                });

                const url = tabTrigger.getAttribute("data-url");
                btnTop.setAttribute("href", url);
                btnBottom.setAttribute("href", url);
            });
        });
    }
}

if(!customElements.get('fs-prod-tabs')){
    customElements.define('fs-prod-tabs', FsProdTabs);
}


class FsTicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        new Swiper(this, {
			slidesPerView: "auto",
			speed: 5000,
			initialSlide: 0,
			loop: true,
			loopedSlides: 50,
			allowTouchMove: false,
			waitForTransition: false,
			watchSlidesProgress: false,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
        });
    }
}

if(!customElements.get('fs-ticker')){
    customElements.define('fs-ticker', FsTicker);
}

class FsEventList extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const events = this.querySelectorAll('.event');

        events.forEach(event => {
            event.addEventListener('mouseover', () => {
                events.forEach(elm => elm.classList.remove('active'));
                event.classList.add('active');
            });
        });
    }
}

if (!customElements.get('fs-event-list')) {
    customElements.define('fs-event-list', FsEventList);
}

class FsDiscount extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const boxs = this.querySelectorAll('.discount_box');

        boxs.forEach(box => {
            box.addEventListener('click', () => {
                const codeBox = box.querySelector('.code');
                const text = codeBox.textContent;

                navigator.clipboard.writeText(text);

                codeBox.textContent = 'Copied';
                setTimeout(() => {
                    codeBox.textContent = text;
                }, 1000);
            });
        });
    }
}

if (!customElements.get('fs-discount-grid')) {
    customElements.define('fs-discount-grid', FsDiscount);
}


class FsPdfBook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const slider = this.querySelector(".swiper");
    const pagination = this.querySelector(".swiper-pagination")
    new Swiper(slider, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      pagination: {
        el: pagination,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },
    });
  }
}

if (!customElements.get('fs-pdf-book')) {
  customElements.define('fs-pdf-book', FsPdfBook);
}



class FsModelsMarquee extends HTMLElement {
  connectedCallback() {
    new Swiper(this, {
      slidesPerView: "auto",
      loop: true,
      speed: 8000,
      freeMode: true,
      // allowTouchMove: false,
      // freeModeMomentum: false,
      autoplay: {
        delay: 0,
        pauseOnMouseEnter: true,
      },
    });
  }
}

if (!customElements.get("fs-models-marquee")) {
  customElements.define("fs-models-marquee", FsModelsMarquee);
}


class FsImageSliderNew extends HTMLElement {
  connectedCallback() {
    new Swiper(this, {
      slidesPerView: 1,
      autoplay: {
        disableOnInteraction: false,
      },
    });
  }
}

if (!customElements.get("fs-image-slider-new")) {
  customElements.define("fs-image-slider-new", FsImageSliderNew);
}


class FsLoader extends HTMLElement {
  connectedCallback() {
    const STORAGE_KEY = "fs_loader_shown";
    if (localStorage.getItem(STORAGE_KEY)){
      this.classList.remove("active");
      return;
    };
    this.classList.add("active_logo");

    window.addEventListener("load", ()=>{
      this.classList.remove("active");
      this.classList.remove("active_logo");
      localStorage.setItem("fs_loader_shown", "true");
      // setTimeout(()=>{
      // }, 500)
    });
  }
}

if (!customElements.get("fs-loader")) {
  customElements.define("fs-loader", FsLoader);
}